function CategoryTileSkeleton() {
  return (
    <div className="flex flex-col items-center px-3 text-center">
      <div className="aspect-square w-full animate-pulse rounded-lg bg-[#F0E0C7]/60" />
      <div className="mt-2 h-4 w-16 animate-pulse rounded bg-[#F0E0C7]/60" />
    </div>
  );
}

function SubSubCategoryTileSkeleton() {
  return (
    <div className="flex w-full flex-col items-center text-center">
      <div className="aspect-square w-full animate-pulse rounded-lg bg-[#F0E0C7]/60" />
      <div className="mt-2 h-3 w-14 animate-pulse rounded bg-[#F0E0C7]/60" />
    </div>
  );
}

export default function CategoriesSkeleton() {
  return (
    <div className="flex">
      <div className="flex h-[calc(100vh-126px)] shrink-0 basis-1/4 flex-col gap-3 overflow-y-auto shadow-[15px_0_20px_-20px_rgba(184,127,44,0.5)] md:basis-1/6 lg:basis-1/10">
        {Array.from({ length: 6 }).map((_, index) => (
          <CategoryTileSkeleton key={index} />
        ))}
      </div>

      <div className="h-[calc(100vh-126px)] flex-1 space-y-2 overflow-y-auto">
        {Array.from({ length: 2 }).map((_, sectionIndex) => (
          <div key={sectionIndex} className="px-4">
            <div className="h-5 w-32 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="grid grid-cols-2 gap-4 p-4 sm:grid-cols-3 sm:gap-3 md:grid-cols-4 md:gap-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7">
              {Array.from({ length: 7 }).map((__, tileIndex) => (
                <SubSubCategoryTileSkeleton key={tileIndex} />
              ))}
            </div>
            <div className="border-b border-[#F2994A] px-4" />
          </div>
        ))}
      </div>
    </div>
  );
}
